import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SVBConnect = {
  isOpen: boolean;
  connectionId?: string;
  entityId?: string;
  groupId?: string;
  txn_pull_choice?: string;
  txn_pull_date?: string;
  connection_successful?: boolean;
  code?: string;
  code_only_mode?: boolean;
};

const initialState: SVBConnect = {
  isOpen: false,
  connectionId: undefined,
  entityId: undefined,
  groupId: undefined,
  txn_pull_choice: undefined,
  txn_pull_date: undefined,
  connection_successful: false,
  code: undefined,
  code_only_mode: false,
};

export const svbConnectSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setSvbConnectModal: (state, action: PayloadAction<SVBConnect>) => {
      state.isOpen = action.payload.isOpen;
      state.connectionId = action.payload.connectionId;
      state.entityId = action.payload.entityId;
      state.groupId = action.payload.groupId;
      state.txn_pull_choice = action.payload.txn_pull_choice;
      state.txn_pull_date = action.payload.txn_pull_date;
      state.connection_successful = action.payload.connection_successful;
      state.code = action.payload.code;
      state.code_only_mode = action.payload.code_only_mode;
    },
  },
});

export const { setSvbConnectModal } = svbConnectSlice.actions;

export default svbConnectSlice.reducer;
